import { DASHBOARD_ROUTES } from '../../helpers/constants'
import { NavLink, useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { TibiContext } from '../../context/ContextProvider'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface AsideNaveMobileProps {
    openSidebarNav: boolean
    setOpenSidebarNav: (value: boolean) => void
}

const AsideNaveMobile = ({ openSidebarNav, setOpenSidebarNav }: AsideNaveMobileProps) => {
    const navigate = useNavigate()
    const { brand } = useContext(TibiContext)

    const menuClassName: string = openSidebarNav ? 'translate-x-0' : '-translate-x-full'
    const overlayClassName: string = openSidebarNav ? 'opacity-20 pointer-events-auto' : 'opacity-0 pointer-events-none'

    return (
        <>
            <nav
                className={`fixed z-50 transition-transform duration-300 ease-in-out top-0 left-0 h-screen w-[300px] border-right lg:hidden bg-white space-y-4 ${menuClassName}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className='flex p-4 items-center gap-x-4 border-btm pb-4 relative'>
                    <button
                        type='button'
                        onClick={(e) => {
                            e.preventDefault()
                            navigate('/dashboard')
                            setOpenSidebarNav(false)
                        }}
                    >
                        <img
                            className='h-[45px] object-cover logo'
                            src={brand?.logo?.default}
                            alt={brand?.organisation}
                        />
                    </button>
                    <button
                        type='button'
                        className='text-[--tb-mainHeading] absolute text-xl right-0 top-0 p-4'
                        onClick={() => setOpenSidebarNav(false)}
                    >
                        <DynamicFaIcon iconName='times' />
                    </button>
                </div>

                <ul>
                    {DASHBOARD_ROUTES.map((route, i) => {
                        return (
                            <li key={i}>
                                <NavLink
                                    to={route.to}
                                    end={route.to === ''}
                                    className={({ isActive }) =>
                                        isActive ? 'text-black relative activeNavLink' : 'relative'
                                    }
                                    onClick={() => setOpenSidebarNav(false)}
                                >
                                    <div className='flex flex-row items-center pl-4 relative'>
                                        {route.icon && (
                                            <span className='mr-3 w-5 flex items-center justify-center'>
                                                <DynamicFaIcon iconName={route.icon.iconName} />
                                            </span>
                                        )}
                                        <span
                                            className={`${
                                                i === DASHBOARD_ROUTES.length - 1 ? 'border-none' : 'border-b'
                                            } flex w-full py-3 borderFadedPrimaryColor border-opacity-50 items-center gap-x-2`}
                                        >
                                            {route.displayName}
                                        </span>
                                    </div>
                            </NavLink>
                            {route.children && (
                                <ul className='pb-1'>
                                    {route.children.map((child) => (
                                        <li key={child.to}>
                                            <NavLink
                                                to={child.to}
                                                className={({ isActive }) =>
                                                    isActive ? 'text-black relative activeNavLink' : 'relative'
                                                }
                                                onClick={() => setOpenSidebarNav(false)}
                                            >
                                                <div className='flex flex-row items-center pl-12 py-2 text-sm'>
                                                    {child.icon && (
                                                        <span className='mr-2 w-4 flex items-center justify-center'>
                                                            <DynamicFaIcon iconName={child.icon.iconName} />
                                                        </span>
                                                    )}
                                                    <span className='font-medium'>{child.displayName}</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                        )
                    })}
                </ul>
            </nav>
            <div
                className={`fixed transition-opacity duration-300 ease-in-out top-0 left-0 w-screen h-screen lg:hidden bg-black z-40 ${overlayClassName}`}
                onClick={() => setOpenSidebarNav(!openSidebarNav)}
            ></div>
        </>
    )
}

export default AsideNaveMobile
